import React from 'react';
import styles from './enrichment-certificates.module.sass';
import { Button, Typography, Table, Tooltip } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { Link } from 'react-router-dom';
import { STATUS } from '../../../../redux/constants';

function EnrichmentCertificates({
  newData,
  statusNew,
  type,
  history,
  oldData,
  parsedData,
  parsedIOCStatus,
  props,
}) {
  const { Title, Text } = Typography;
  let certificates = undefined;

  if (type === 'domain') {
    certificates = newData?.response?.scan_data?.certificates?.[0];
  } else if (type === 'ipv4') {
    if (newData?.response?.ip2asn) {
      certificates =
        newData?.response?.ip2asn?.[0]?.scan_data?.certificates?.[0];
    }
  }

  function handleLookup(name) {
    let exploreType;

    if (type === 'domain') {
      if (name?.includes(':')) {
        exploreType = 'ANYIPV6';
      } else if (!name?.includes(':')) {
        exploreType = 'ANYIPV4';
      }
    } else if (type === 'ipv4') {
      exploreType = 'any';
    }

    return (
      `/explore-result?name=${name}&queryType=query&type=${exploreType}&backLink=` +
      encodeURIComponent(window.location.pathname) +
      encodeURIComponent(window.location.search) +
      '&origin_uid=Explore'
    );
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
    },
  ];

  function returnTableData({ loading, iocType }) {
    return [
      {
        key: 1,
        name: iocType === 'domain' ? 'IP' : 'Domain',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <div className={styles.domain_table_row}>
            <Text className="me-1" strong>
              {iocType === 'domain'
                ? certificates?.ip
                  ? certificates?.ip
                  : '-'
                : certificates?.domain
                ? certificates?.domain
                : '-'}
            </Text>
            {props?.mySubscriptionPlan?.has_access_to_explore ? (
              <Link
                to={() =>
                  handleLookup(
                    iocType === 'domain'
                      ? certificates?.ip
                      : certificates?.domain,
                  )
                }
              >
                <Button
                  type="primary"
                  //onClick={() =>
                  // handleLookup(
                  //   iocType === 'domain'
                  //     ? certificates?.ip
                  //     : certificates?.domain,
                  // )
                  //}
                  disabled={
                    iocType === 'domain'
                      ? !certificates?.ip?.length
                      : !certificates?.domain?.length
                  }
                >
                  Lookup PADNS
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_explore ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button type="primary" disabled={true}>
                  Lookup PADNS
                </Button>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        key: 2,
        name: 'Domains',
        value: loading ? (
          <>
            <LoadingSkeleton /> <LoadingSkeleton /> <LoadingSkeleton />
          </>
        ) : (
          <div className={styles.domain_container}>
            {certificates?.domains && certificates?.domains?.length > 0 ? (
              certificates?.domains?.map((domain) => (
                <Text strong>{domain}</Text>
              ))
            ) : (
              <Text strong>-</Text>
            )}
          </div>
        ),
      },
      {
        key: 3,
        name: 'SHA1',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {certificates?.fingerprint_sha1
              ? certificates?.fingerprint_sha1
              : '-'}
          </Text>
        ),
      },
      {
        key: 4,
        name: 'Valid From',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {certificates?.not_before ? certificates?.not_before : '-'}
          </Text>
        ),
      },
      {
        key: 5,
        name: 'Valid Until',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {certificates?.not_after ? certificates?.not_after : '-'}
          </Text>
        ),
      },
      {
        key: 6,
        name: 'Issuer Common Name',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {certificates?.issuer_common_name
              ? certificates?.issuer_common_name
              : '-'}
          </Text>
        ),
      },
      {
        key: 7,
        name: 'Issuer Organization',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {certificates?.issuer_organization
              ? certificates?.issuer_organization
              : '-'}
          </Text>
        ),
      },
      {
        key: 8,
        name: 'Scan Date',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <Text strong>
            {certificates?.scan_date ? certificates?.scan_date : '-'}
          </Text>
        ),
      },
    ];
  }

  return (
    <div className={styles.enrichment_certificates}>
      <div className={styles.title}>
        <Title level={4}>Certificates</Title>
        {props?.mySubscriptionPlan?.has_access_to_query_builder &&
        parsedIOCStatus === STATUS.LOADED ? (
          <Link
            to={
              type === 'domain'
                ? `/explore-result?name=${parsedData?.result
                    ?.replace('[', '')
                    ?.replace(']', '')
                    ?.trim()}&queryType=certificates&type=certificates&fromQueryBuilder=true&backLink=${encodeURIComponent(
                    window.location.pathname,
                  )}${encodeURIComponent(
                    window.location.search,
                  )}&originalQueryURL=scandata%2Fipv4%2Fcertificates%3Fnetmask%3D32%26domain%3D${parsedData?.result
                    ?.replace('[', '')
                    ?.replace(']', '')
                    ?.trim()}%26window%3D180%26limit%3D100%26max_wait%3D25%26with_metadata%3D1&origin_uid=CERTIFICATES`
                : `/explore-result?name=${parsedData?.result
                    ?.replace('[', '')
                    ?.replace(']', '')
                    ?.trim()}&queryType=certificates&type=certificates&fromQueryBuilder=true&backLink=${encodeURIComponent(
                    window.location.pathname,
                  )}${encodeURIComponent(
                    window.location.search,
                  )}&originalQueryURL=scandata%2Fipv4%2Fcertificates%3Fnetmask%3D32%26ipv4%3D${parsedData?.result
                    ?.replace('[', '')
                    ?.replace(']', '')
                    ?.trim()}%26window%3D180%26limit%3D100%26max_wait%3D25%26with_metadata%3D1&origin_uid=CERTIFICATES`

              // type === 'domain'
              //   ? `/explore/query-builder?query=cf2c717a-ebd4-44be-87ab-5028a52dd78d&domain=${parsedData?.result}&backLink=` +
              //     encodeURIComponent(window.location.pathname) +
              //     encodeURIComponent(window.location.search)
              //   : `/explore/query-builder?query=cf2c717a-ebd4-44be-87ab-5028a52dd78d&ipv4=${parsedData?.result}&backLink=` +
              //     encodeURIComponent(window.location.pathname) +
              //     encodeURIComponent(window.location.search)
            }
          >
            <Button type="primary">Show all associated certificates</Button>
          </Link>
        ) : (
          <Tooltip
            title={
              props?.mySubscriptionPlan?.has_access_to_query_builder ? (
                ''
              ) : (
                <>
                  This option is not part of this subscription plan. To upgrade
                  your subscription contact us at{' '}
                  <a target="_blank" href="mailto:sales@silentpush.com">
                    sales@silentpush.com
                  </a>
                  .
                </>
              )
            }
          >
            <Button
              disabled={!props?.mySubscriptionPlan?.has_access_to_query_builder}
              type="primary"
            >
              Show all associated certificates
            </Button>
          </Tooltip>
        )}
      </div>
      <Table
        columns={columns}
        dataSource={returnTableData({
          loading:
            statusNew === 'loading' && parsedIOCStatus === STATUS.LOADING,
          iocType: type,
        })}
        pagination={false}
      />
    </div>
  );
}

export default EnrichmentCertificates;
